export const handleDragSection = sectionClassName => {
    const sectionDraggable = document.querySelector(`.${sectionClassName}`);

    let isDragging = false;
    let startX;
    let scrollLeft;

    sectionDraggable.addEventListener('mousedown', e => {
        isDragging = true;
        sectionDraggable.classList.add('active');
        startX = e.pageX - sectionDraggable.offsetLeft;
        scrollLeft = sectionDraggable.scrollLeft;
    });

    sectionDraggable.addEventListener('mouseleave', () => {
        isDragging = false;
        sectionDraggable.classList.remove('active');
    });

    sectionDraggable.addEventListener('mouseup', () => {
        isDragging = false;
        sectionDraggable.classList.remove('active');
    });

    sectionDraggable.addEventListener('mousemove', e => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - sectionDraggable.offsetLeft;
        const walk = (x - startX) * 2;
        sectionDraggable.scrollLeft = scrollLeft - walk;
    });
};
